import React from 'react';
import { BookOpen, MessageCircle, User } from 'lucide-react';

/**
 * Navigation bar component that handles view switching and displays the main app title
 */
const NavBar = ({ currentView, setCurrentView }) => (
  <nav className="bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 text-white shadow-xl">
    <div className="max-w-7xl mx-auto px-4">
      <div className="flex justify-between items-center h-16">
        <div className="flex items-center space-x-3">
          <div className="bg-white/20 p-2 rounded-lg">
            <BookOpen className="w-8 h-8" />
          </div>
          <div>
            <h1 className="text-2xl font-bold bg-gradient-to-r from-yellow-200 to-pink-200 bg-clip-text text-transparent">
              Bookify
            </h1>
            <p className="text-xs text-blue-100">Your Literary Universe</p>
          </div>
        </div>
        
        <div className="flex space-x-2">
          <button 
            onClick={() => setCurrentView('home')}
            className={`px-4 py-2 rounded-full transition-all duration-300 flex items-center space-x-1 ${
              currentView === 'home' 
                ? 'bg-white/30 shadow-lg' 
                : 'hover:bg-white/20'
            }`}
          >
            <BookOpen className="w-4 h-4" />
            <span>Books</span>
          </button>
          
          <button 
            onClick={() => setCurrentView('chat')}
            className={`px-4 py-2 rounded-full transition-all duration-300 flex items-center space-x-1 ${
              currentView === 'chat' 
                ? 'bg-white/30 shadow-lg' 
                : 'hover:bg-white/20'
            }`}
          >
            <MessageCircle className="w-4 h-4" />
            <span>AI Assistant</span>
          </button>
          
          <button 
            onClick={() => setCurrentView('admin-login')}
            className={`px-4 py-2 rounded-full transition-all duration-300 flex items-center space-x-1 ${
              currentView === 'admin-login' 
                ? 'bg-white/30 shadow-lg' 
                : 'hover:bg-white/20'
            }`}
          >
            <User className="w-4 h-4" />
            <span>Admin</span>
          </button>
        </div>
      </div>
    </div>
  </nav>
);

export default NavBar;
